var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.team),function(name,key){return _c('player-badge',{key:key,attrs:{"name":name}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }